function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M456,328h-8V160h8c13.255,0,24-10.745,24-24s-10.745-24-24-24h-8v-12c-0.041-10.777-6.263-20.573-16-25.192V32 c0-13.255-10.745-24-24-24H296c-13.255,0-24,10.745-24,24v40.408C258.259,74.37,248.039,86.119,248,100v12h-16v-12 c0-15.464-12.536-28-28-28s-28,12.536-28,28v12h-16v-12c0-15.464-12.536-28-28-28s-28,12.536-28,28v12H88v-12 c0-15.464-12.536-28-28-28s-28,12.536-28,28v12h-8c-13.255,0-24,10.745-24,24s10.745,24,24,24h8v168h-8c-13.255,0-24,10.745-24,24 s10.745,24,24,24h8.408C34.37,389.741,46.119,399.961,60,400c1.341-0.038,2.678-0.175,4-0.408V456H16c-4.418,0-8,3.582-8,8 s3.582,8,8,8h448c4.418,0,8-3.582,8-8s-3.582-8-8-8h-48v-56.408c1.322,0.233,2.659,0.37,4,0.408 c13.881-0.039,25.63-10.259,27.592-24H456c13.255,0,24-10.745,24-24S469.255,328,456,328z M448,128h8c4.418,0,8,3.582,8,8 s-3.582,8-8,8h-8V128z M32,360h-8c-4.418,0-8-3.582-8-8s3.582-8,8-8h8V360z M32,144h-8c-4.418,0-8-3.582-8-8s3.582-8,8-8h8V144z  M72,372c0,6.627-5.373,12-12,12s-12-5.373-12-12V100c0-6.627,5.373-12,12-12s12,5.373,12,12V372z M88,128h16v232H88V128z  M112,456H80v-16h32V456z M112,392v32H80v-32c0-0.136-0.072-0.24-0.072-0.376c4.157-4.256,6.843-9.731,7.664-15.624h16.8 c0.821,5.893,3.507,11.368,7.664,15.624C112.072,391.76,112,391.864,112,392z M264,100c0-6.627,5.373-12,12-12 c6.627,0,12,5.373,12,12v272c0,6.627-5.373,12-12,12c-6.627,0-12-5.373-12-12V100z M232,128h16v232h-16V128z M192,100 c0-6.627,5.373-12,12-12c6.627,0,12,5.373,12,12v272c0,6.627-5.373,12-12,12c-6.627,0-12-5.373-12-12V100z M160,128h16v232h-16 V128z M120,372V100c0-6.627,5.373-12,12-12c6.627,0,12,5.373,12,12v272c0,6.627-5.373,12-12,12C125.373,384,120,378.627,120,372z  M352,456H128v-56.408c1.322,0.233,2.659,0.37,4,0.408c13.881-0.039,25.63-10.259,27.592-24h16.8 c2.113,15.243,16.183,25.887,31.427,23.773c12.351-1.712,22.061-11.422,23.773-23.773h16.8 c2.113,15.243,16.183,25.887,31.427,23.773c12.351-1.712,22.061-11.422,23.773-23.773h16.8c1.963,13.747,13.721,23.969,27.608,24 c1.341-0.038,2.678-0.175,4-0.408V456z M304,360V128h16v232H304z M360,372c0,6.627-5.373,12-12,12c-6.627,0-12-5.373-12-12V100 c0-6.627,5.373-12,12-12c6.627,0,12,5.373,12,12V372z M400,456h-32v-16h32V456z M400,392v32h-32v-32 c0-0.136-0.072-0.24-0.072-0.376c4.157-4.256,6.843-9.731,7.664-15.624h16.8c0.821,5.893,3.507,11.368,7.664,15.624 C400.072,391.76,400,391.864,400,392z M376,360V128h16v232H376z M392,100v12h-16v-12c0-15.464-12.536-28-28-28 c-15.464,0-28,12.536-28,28v12h-16v-12c-0.041-10.777-6.263-20.573-16-25.192V32c0-4.418,3.582-8,8-8h112c4.418,0,8,3.582,8,8 v40.408C402.259,74.37,392.039,86.119,392,100z M432,372c0,6.627-5.373,12-12,12c-6.627,0-12-5.373-12-12V100 c0-6.627,5.373-12,12-12c6.627,0,12,5.373,12,12V372z M456,360h-8v-16h8c4.418,0,8,3.582,8,8S460.418,360,456,360z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 312,
  cy: 48,
  r: 16
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 352,
  cy: 48,
  r: 16
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 392,
  cy: 48,
  r: 16
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

function SvgHeating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeating);
export default __webpack_public_path__ + "static/media/heating.8cb6afc3.svg";
export { ForwardRef as ReactComponent };